const EditorReducer = (
  state = {
    autoPlayPauseActive: false
  },
  action
) => {
  switch (action.type) {
    case 'UPDATE_CONTENT':
      return {
        ...state,
        content: action.content,
        lastSave: action.lastSave,
        hasNewChanges: true
      };
    case 'SET_SPEAKER_LABEL':
      return { ...state, speaker: action.speaker, hasNewChanges: true };
    case 'SET_AUTO_PLAY_PAUSE_ACTIVE':
      return { ...state, autoPlayPauseActive: action.active };
    case 'SAVED':
      return { ...state, hasNewChanges: false, lastSave: action.lastSave };
    default:
      return state;
  }
};

export default EditorReducer;
